class UnderlineElement extends HTMLElement {
	constructor() {
		super();
	}
	connectedCallback() {
		this.underlineSymbol = '&';
		this._render(this.underlineSymbol);
	}
	_render(symbol) {
    const escapedSymbol = symbol.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const div = document.createElement('div');
    div.innerHTML = this.innerHTML;
    div.innerHTML = div.innerHTML.replace(/&amp;/g, '');
    div.innerHTML = div.innerHTML.replace(new RegExp(`${escapedSymbol}(.*?)${escapedSymbol}`, 'g'), '<u class="reduced-font">$1</u>');
    this.innerHTML = '';
    this.appendChild(div);
	}
}

if (!customElements.get('underline-element')) {
	customElements.define('underline-element', UnderlineElement);
}
